import DefaultLayout from "../components/layout/DefaultLayout";
import PageMetadata from "../components/layout/PageMetadata.jsx";
import PiRunnerGame from "../components/games/pi-runner/PiRunnerGame.jsx";
import "./PiRunner.css";

function PiRunner() {
    return (
        <>
            <PageMetadata 
                title="Pi Runner"
                description="Pi Runner is a browser game where goal is to memorize digits of Pi to help the character run further."
                canonical="https://studycorner.cc/pi-runner"
                og={{
                    title: "Pi Runner",
                    description: "How many digits of Pi can you memorize?",
                    url: "https://studycorner.cc/pi-runner",
                    type: "website"
                }}
                schema={{
                    "@context": "https://schema.org",
                    "@type": "SoftwareApplication",
                    "name": "Pi Runner",
                    "applicationCategory": "GameApplication",
                    "operatingSystem": "Web",
                    "url": "https://studycorner.cc/pi-runner",
                    "description": "Pi Runner is a browser game where goal is to memorize digits of Pi to help the character run further."
                }}
            />
            <DefaultLayout>
                {/* hidden content for SEO */}
                <div className="seo-only">
                    <h1>Pi Runner - A Game to Memorize Digits of Pi</h1>
                    <p>
                        Pi Runner is an educational browser game designed to help gamify memorization of the digits of Pi in a fun and way. 
                        Each correct digit helps your character run further, turning memory practice into a challenge.
                    </p>
                </div>

                <div className="game-container">
                    <PiRunnerGame />
                </div>
            </DefaultLayout>
        </>
    );
}

export default PiRunner;